import { render, staticRenderFns } from "./ContactInfo3.vue?vue&type=template&id=f1168aee&scoped=true&"
import script from "./ContactInfo3.vue?vue&type=script&lang=js&"
export * from "./ContactInfo3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1168aee",
  null
  
)

export default component.exports